import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { cn } from "utils/cn";

const statusColors = {
  success: "text-success bg-success/10",
  warning: "text-warning bg-warning/10",
  destructive: "text-destructive bg-destructive/10",
  info: "text-primary bg-primary/10",
};

export default function MetricCard({
  title,
  value,
  change,
  icon: Icon,
  status = "info",
  subMetrics = [],
}) {
  const hasChange = typeof change === "number";
  const hasSubMetrics = Array.isArray(subMetrics) && subMetrics.length > 0;
  const subMetricColumns = subMetrics.length > 1 ? "grid-cols-2" : "grid-cols-1";
  const TrendIcon = hasChange ? (change > 0 ? TrendingUp : change < 0 ? TrendingDown : Minus) : null;
  const trendColor = hasChange
    ? change > 0
      ? "text-success"
      : change < 0
        ? "text-destructive"
        : "text-muted-foreground"
    : "text-muted-foreground";

  return (
    <div
      className={cn(
        "metric-card animate-fade-in p-3 md:p-4",
        hasSubMetrics ? "min-h-[156px]" : "min-h-[120px]",
      )}
    >
      <div className="mb-2.5 flex items-start justify-between">
        <div className={cn("rounded-md p-1.5", statusColors[status] || statusColors.info)}>
          <Icon className="h-4 w-4" />
        </div>
        {hasChange && (
          <div className={cn("flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] font-medium", trendColor)}>
            <TrendIcon className="h-3 w-3" />
            <span>{Math.abs(change)}%</span>
          </div>
        )}
      </div>
      <p className="text-xl md:text-2xl font-bold tracking-tight leading-none">{value}</p>
      <p className="mt-1 text-xs text-muted-foreground">{title}</p>
      {hasSubMetrics && (
        <div className={cn("mt-2.5 grid gap-1.5 border-t border-border/70 pt-2.5", subMetricColumns)}>
          {subMetrics.map((item) => (
            <div key={item.label} className="rounded-md bg-muted/40 px-2 py-1.5">
              <p className="text-[11px] text-muted-foreground">{item.label}</p>
              <p className="text-xs md:text-sm font-semibold text-foreground leading-tight">{item.value}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
